import Vue from 'vue';
import Loading from '@/components/loading/Loading';
import GdConfig from '@/gdConfig';
import theme from '@/mixins/theme';
import router from './router';
import store from './store';
import vuetify from './vuetify';
import i18n from './i18n';
import './axios';
import './vee-validate';
import './bootstrap';

if (window.gd_settings) {
  Vue.prototype.$gd = new GdConfig(window.gd_settings.theme, window.gd_settings.text);
}

new Vue({
  el: '#app',
  mixins: [theme],
  router,
  store,
  vuetify,
  i18n,
  components: {
    Loading,
  },
  mounted() {
    this.$loading = this.$refs.loading;
  },
});
